// client/src/App.js

import React from "react";
import logo from "../logo.svg";
import "../App.css";
import CommonContext from '../commonContext';
import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  HStack,
  useToast,
  Badge,
  Image,
  Divider,
  Grid,
  GridItem
} from '@chakra-ui/react';
import { postCall } from '../utils/requests';

function NotificationsPage() {

  const [data, setData] = React.useState(null);
  const [title, setTitle] = React.useState("");
  const [body, setBody] = React.useState("");
  const [idVideo, setIdVideo] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const toast = useToast();

  const commonContext = React.useContext(CommonContext);

  React.useEffect(() => {

    commonContext.setCurrentPath("Notifiche")
    commonContext.setCurrentPage("notifications")

  }, []);


  const sendNotification = async () => {

    setLoading(true);

    let resp = await postCall("/notifyTopic", {
     
      message: body,
      title: title,
      imageUrl: "",
      iconUrl: "",
      topic: "all_users",
      id_video: idVideo
     /*  token: "dKxpSxWNSnuCfq9EdKyylH:APA91bGbvGJnqE11rvw9nO-gT26-upv1awNQ9FhkfTQv0TSX49UXvx-0fwUomCkIZ0vXm9ggyP0VLdFjZAFodcsphAQni882FfwteiUmgQ8OOrjFRzgt0XxJhBgKjWn4zOWu1Jnevo-C" */
    })
    if (resp !== undefined && resp !== null && resp.status === "success") {
      toast({
        title: "Perfetto",
        description: "Notifica inviata!",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      /* TODO decomment */
      /* setBody("");
      setTitle("");
      setIdVideo(""); */
      setLoading(false);
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setLoading(false);
    }
  }



  return (
    <div>
      <Flex justifyContent="center">
        <Box p="30px" mt="2%" ml="5%" w="50%" bg="blue.200" borderRadius="lg">
          <Flex justifyContent="center">
            <Text fontSize="2xl" justifyContent="center" textAlign="center" className='adlam-font' fontWeight="bold">
              Invia una notifica in tempo reale a tutti gli utenti che hanno installato l'applicazione
            </Text>
          </Flex>
          <Center>
            <Divider mt="40px" w="90%"></Divider>
          </Center>
          <form>
            {/* <button type="submit">Upload</button> */}
            <FormControl id="categoryName">

              <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>

                <GridItem rowSpan={1} colSpan={2} >
                  <FormLabel mt="25px">Titolo</FormLabel>
                  <Input
                    bg="white"
                    type="text"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                  />
                </GridItem>
                <GridItem rowSpan={1} colSpan={2} >
                  <FormLabel>Messaggio</FormLabel>
                  <Textarea
                    resize="none"
                    bg="white"
                    mb="20px"
                    type="text"
                    value={body}
                    onChange={(event) => setBody(event.target.value)}
                  />
                </GridItem>
                <GridItem rowSpan={1} colSpan={1} >
                  <FormLabel>ID video</FormLabel>
                  <Input
                    resize="none"
                    bg="white"
                    mb="20px"
                    w="40%"
                    type="text"
                    value={idVideo}
                    onChange={(event) => setIdVideo(event.target.value)}
                  />
                </GridItem>
              </Grid>
            </FormControl>
          </form>
          <Flex justifyContent="center">
            <Button type="submit" colorScheme="green" onClick={sendNotification}>Invia!</Button>

          </Flex>
        </Box>
      </Flex>
      {/* BEGIN - LOADING */}
      {loading &&

        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={9999}
          pointerEvents="none">
          <Box
            h="300"
            w="300"
            borderRadius="md"
            backgroundColor="white"
            zIndex={9999}
            display="flex"


          >
            <Flex h="300px" alignItems="center" justifyContent="center">
              <Stack spacing={5} w="300px">
                <Center>
                  <Text fontSize="xl" as="b" color="teal">Invio notifica</Text>
                </Center>
                <Center >
                  <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                  />
                </Center>
              </Stack>
            </Flex>
          </Box>
        </Box>
      }

      {/* END - LOADING */}

    </div>
  );
}

export default NotificationsPage;